var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _path2, _path3, _path4, _rect1, _path5, _path6, _path7, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #928980;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #331e11;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.16,
    y: 49.41,
    width: 2.98,
    height: 9.91,
    transform: "translate(10.8 -10.05) rotate(10.4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.16,
    y: 21.07,
    width: 2.98,
    height: 9.91,
    transform: "translate(-3.37 9.98) rotate(-9.15)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.66,
    y: 45.38,
    width: 11.69,
    height: 3.95
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.32,
    y: 45.92,
    width: 18.72,
    height: 6.46
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.52,
    y: 27.39,
    width: 4.26,
    height: 10.83,
    transform: "translate(70.45 -4.84) rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.92,
    y: 28.53,
    width: 17.28,
    height: 6.81
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 70.39,
    y: 37.62,
    width: 3.21,
    height: 4.35
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.87,
    y: 38.55,
    width: 3.21,
    height: 5.36
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.39,
    y: 35.87,
    width: 3.2,
    height: 8.68
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.03,
    y: 31.28,
    width: 6.4,
    height: 17.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.07,31.62h5.5c.15,0,.26,.12,.26,.26v16.48c0,.15-.12,.26-.26,.26h-2.57c-3.47,0-6.29-2.82-6.29-6.29v-7.36c0-1.85,1.5-3.36,3.36-3.36Z",
    transform: "translate(106.56 80.24) rotate(180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.17,33.33h5.89v13.64h-6.48c-1.75,0-3.18-1.42-3.18-3.18v-6.68c0-2.08,1.69-3.78,3.78-3.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.82,32.39h3.03v15.39h-3.15c-2.55,0-4.63-2.07-4.63-4.63v-6.02c0-2.62,2.12-4.74,4.74-4.74Z",
    transform: "translate(65.94 80.17) rotate(180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.02,35.34h3.69v10.04h-3.8v-9.93c0-.06,.05-.11,.11-.11Z",
    transform: "translate(75.61 80.72) rotate(180)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.48,
    y: 35.73,
    width: 4.58,
    height: 8.79
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.57,31.32h4.79c.4,0,.73,.33,.73,.73v16.32c0,.4-.33,.73-.73,.73h-5.97c-3.3,0-5.98-2.68-5.98-5.98v-4.63c0-3.96,3.21-7.17,7.17-7.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.66,37.88v5.45m0-5.45l1.64-2.42h2.19m-3.84,2.42h-3.29l-1.1,1.21v3.03l1.1,1.21h3.29m0,0l1.64,1.82h2.19m2.19,0l3.84,3.64,5.48,1.21,6.58-2.42,7.12-2.42,1.1-.61,2.74,1.38m-26.85-.77v-9.7m0,9.7h-2.19m42.74,1.82l-.55,1.21-4.93,.61-4.93-1.21-3.29-1.65m13.7,1.05l1.1,3.03,.86-.16m-1.95-2.87v-13.94l.55-1.21v-1.21l.55-.61,.82,.61m6.3,14.55l-1.1,2.42v1.82h-1.1m2.19-4.24l4.13-.61,.52-1.21h1.03l2.06-1.21,.52-1.21v-2.42l-1.55-1.21h-1.55l-.52-.3m-4.65,8.18v-9.7m4.93,1.52v5.76m0-5.76l-2.19-1.52h-2.74m0,0l-.55-2.42-.82-.91-.82-.91m0,0l-1.1-.61-2.19,.61-.82-.61m4.11,.61l-1.1-7.27-.82-.61-1.37-3.03-1.64,.61,.43,3.03-.43,.61,.41,3.03,.41,3.03m-2.47,2.42l-2.19-1.21h-3.84l-2.74,1.21-3.29,1.36m-27.95,1.06l4.04-3.64,4.18-1.21,3.29,.61,2.19,.61,3.84,1.82,6.58,1.82,2.74-.61,1.1-.45m-27.95,1.06h-2.19m0,9.7v2.42h-2.19v3.03h2.19v2.42h17.53v-3.03h8.77l1.64-1.82,1.1-2.26m15.65,3.92l2.43-.45h1.64m-4.08,.45l-.43,3.11-.43,3.11,.55,.61-.55,3.03h2.19l.82-3.03,.82-.61,1.1-6.67m-18.63-15l-1.64-2.58-2.19-1.82h-7.67v-2.42H14.5v2.42h-2.74v3.03h2.74v2.42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.59,35.62v9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.32,
    y: 39.42,
    width: 0.42,
    height: 1.19
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.05,
    y: 38.1,
    width: 0.27,
    height: 3.39
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.63,
    y: 30.35,
    width: 3.21,
    height: 2.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.a3550ff8e39199a42df6232b01216ea1.svg";
export { ForwardRef as ReactComponent };